import React from 'react'
import "./foodCard.scss";
import Button from "../button/Button";
import { Link, useLocation } from 'react-router-dom';
import PropTypes from "prop-types"

const FoodCard = props => {
    const location = useLocation().pathname;
    const path = location + `/${props.id}`
    return (
        <Link to={path}>
        <div className="category-card" style={{ backgroundImage: `url(${props.image})` }}>
            <Button>View</Button>
        </div>
            <h3>{props.title}</h3>
        </Link>
    )
}

FoodCard.propTypes = {
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}
export default FoodCard